module.exports = __webpack_public_path__ + "assets/img/AIF-Australian-Institute-of-Fitness-Page-Resource-w540.df33fbca.jpg";